import React from "react";

import { useI18n } from "Hooks";
import { Avatar, Button, Modal } from "@toddle-edu/ds-web";

import classes from "./ChildConnectionSuccessV2.scss";

const ChildConnectionSuccessV2 = props => {
  const { onClose, profileImage, studentName } = props;

  const { t } = useI18n();

  return (
    <Modal
      dsVersion="2.0"
      width="480px"
      height={"fit-content"}
      isOpen={true}
      onClose={onClose}
    >
      <Modal.Header
        isClosable
        style={{
          padding: "24px",
        }}
      ></Modal.Header>
      <Modal.Body>
        <div className={classes.modalContent}>
          <Avatar
            size="medium"
            src={profileImage}
            name={studentName}
            className={classes.avatar}
          ></Avatar>
          <div className={classes.contentContainer}>
            <div className="heading-5">
              {t("common:view_student_work", { studentName })}
            </div>
            <div className={`text-body ${classes.subtleText}`}>
              {t("common:view_student_classword_subheading_v2", {
                studentName,
              })}
            </div>
          </div>
          <Button
            size="medium"
            dsVersion="2.0"
            variant="primary"
            type="fill"
            className={`text-label ${classes.buttonContainer}`}
            onClick={onClose}
          >
            {t("common:get_started")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChildConnectionSuccessV2;
